var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{class:("text-caption " + (_vm.status === 'typical' ? 'black--text' : 'white--text')),attrs:{"small":"","color":_vm.getColor(_vm.status)}},[_vm._v("\n  "+_vm._s(_vm.getText(_vm.status))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }